export default __webpack_public_path__ + "static/media/done.e934e342.svg";